import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import "../../Styles/Charts.css";
import { useSelector } from "react-redux";
const PerformanceChart = () => {
  const { strategygraph } = useSelector((state) => state.strategy);
  const transformData = () => {
    return strategygraph?.map((item) => [
      new Date(item.date).getTime(),
      item.returns.toFixed(1),
    ]);
  };

  useEffect(() => {
    setchartdata((prevState) => ({
      ...prevState,
      series: [
        {
          data: transformData(),
        },
      ],
    }));
  }, [strategygraph]);
  const [selection, setselection] = useState("one_year");
  const [chartdata, setchartdata] = useState({
    series: [
      {
        data: transformData(),
      },
    ],
    options: {
      chart: {
        id: "area-datetime",
        type: "area",
        height: 50,
        zoom: {
          autoScaleYaxis: true,
        },
      },
      grid: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },
      xaxis: {
        type: "datetime",
        min: "2023-10-23",
        tickAmount: 6,
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
        grid: {
          show: false,
        },
      },
    },
  });

  function formatDate(dateString) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(dateString);
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();

    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";

    const formattedTime = `${hour}:${minute < 10 ? "0" + minute : minute} ${
      hour >= 12 ? "pm" : "am"
    } utc`;

    return `${dayName}, ${monthName} ${day}${suffix} ${formattedTime}`;
  }

  const dateString = strategygraph ? strategygraph[0]?.date : new Date();

  return (
    <>
      {strategygraph?.length != 0 && strategygraph != null ? (
        <>
          <div id="chart">
            <div className="toolbar">
              <div
                className="row"
                style={{
                  marginTop: "10px",
                  marginLeft: "8px",
                  marginBottom: "-10px",
                }}
              >
                <div className="col-6">
                  <p style={{ color: "#1BA0F4" }}>
                    <b style={{ color: "black", fontSize: "19px" }}>$5,000</b>{" "}
                    2.3%($30){" "}
                  </p>
                  <p
                    style={{
                      marginTop: "-15px",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Strategy Created: {formatDate(dateString)}
                  </p>
                </div>

             
              </div>
            </div>

            <div id="chart-timeline" style={{ height: "300px" }}>
              <ReactApexChart
                options={chartdata.options}
                series={chartdata.series}
                type="area"
                height={220}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "14%",
            }}
          >
            No Strategy Performance Data Available
          </div>
        </>
      )}
    </>
  );
};

export default PerformanceChart;
